import styled from "styled-components"

export const DAWorkTogetherMain = styled.div`
  padding: 100px 0 0;
`
